import React from 'react';
import { theme } from '../../styles/theme';

const Tab = ({ children, isActive, onClick, disabled }) => (
  <button
    className={`px-6 py-3 rounded-lg transition-all duration-200 flex-grow text-sm md:text-base font-medium
    ${!disabled && !isActive && 'hover:shadow-md transform hover:-translate-y-0.5'}`}
    onClick={onClick}
    disabled={disabled}
    style={
      isActive 
        ? {
            background: `linear-gradient(to right, ${theme.colors.primary.main}, ${theme.colors.primary.hover})`,
            color: theme.colors.text.light,
            boxShadow: theme.shadows.md
          }
        : disabled 
          ? {
              backgroundColor: theme.colors.neutral.light,
              color: theme.colors.neutral.main,
              cursor: 'not-allowed'
            }
          : {
              backgroundColor: 'white',
              color: theme.colors.text.secondary,
              ':hover': {
                backgroundColor: theme.colors.neutral.lighter,
                color: theme.colors.primary.main
              }
            }
    }
  >
    {children}
  </button>
);

const RCANavigation = ({ activeTab, onTabChange, project, standalone = false }) => {
  const mainTabs = [
    { id: 'project-init', label: 'Project Initialization' },
    { id: 'problem-definition', label: 'Problem Definition' },
    { id: 'root-cause-identification', label: 'Root Cause Identification' },
    { id: 'corrective-action-plan', label: 'Corrective Action Plan' },
    { id: 'report-generator', label: 'Report Generator' }
  ];

  const containerClasses = `
    bg-white
    ${standalone ? 'shadow-lg rounded-b-2xl py-6 mb-8' : 'py-4'}
  `.trim();

  return (
    <div className={containerClasses} style={standalone ? { borderBottom: `1px solid ${theme.colors.border.light}` } : {}}>
      <nav className="flex flex-wrap gap-2 px-6">
        {mainTabs.map((tab) => (
          <Tab
            key={tab.id}
            isActive={activeTab === tab.id}
            onClick={() => onTabChange(tab.id)}
            disabled={!project && tab.id !== 'project-init'}
          >
            {tab.label}
          </Tab>
        ))}
      </nav>
    </div>
  );
};

export default RCANavigation;
